<!-- 登录页面 -->
<template>
  <div>
      <headerBar/>
      <div class="focus-area">
        <div class="zk-inner">
            <div class="txt-area wow fadeInDown" data-wow-delay="0.2s">
                <strong class="" data-wow-duration="2s" data-wow-offset="10">诸葛·智享</strong>
                <span class="" data-wow-delay="0.2s">智慧供应链商家开放平台</span>
                <p class="" data-wow-delay="0.5s">
                   将行业领先的供应链管理理念，结合京东YAIR（Y AI Platform for Retail）零售行业人工智能平台提供的大数据和算法能力平台化、产品化，通过提供精细化、智能化、自动化库存决策产品，为商家提供最优库存管理决策支持，将更专业的智慧供应链全链路解决方案开放赋能

                </p>
            </div>
            <div class="animation-area">
                <div class="animation-inner">
                    <div class="lazy a1 wow fadeInUp"></div>
                    <div class="a2 wow fadeInUp"></div>
                    <div class="a3 wow fadeInUp" data-wow-delay="0.2s"></div>
                    <div class="a4 wow fadeInDown" data-wow-delay="0.3s"></div>
                    <div class="a5 wow fadeInDown"></div>
                    <div class="a6 wow fadeInUp"></div>
                    <div class="a7 wow fadeInUp"></div>
                    <div class="lg wow fadeInDown" data-wow-delay="0.5s"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="zk-inner">
        <div class="product-info">
            <h1 class="wow fadeInUpMin">产品介绍</h1>
            <div class="row group1">
                <div class="col6 wow fadeInUpMin">
                    <div class="pro-box" style="margin-left:200px;">
                        <img src="../../../assets/images/index-pic1.png" class="img-area pic1">
                        <strong>存货布局</strong>
                        <p>通过数据挖掘，分析商家的经营数据、存货布局的现状，
                        结合大数据预测结果洞悉商家未来的经营趋势，模拟仿真，在商家期望的时效渗透率及成本约束下，给出极值的分仓建议，提升用户体验
                        </p>
                    </div>
                </div>
                <div class="col6 wow fadeInUpMin" data-wow-delay="0.2s">
                    <div class="pro-box" style="margin-left:50px;">
                        <img src="../../../assets/images/index-pic2.png" class="img-area pic2">
                        <strong>库存健康</strong>
                        <p>
                        依托经典库存管理体系，不断拥抱人工智能和精准定位来链接客户，
                        集库存监控、库存诊断及优化建议、商品分类处理执行、供应链全链路运营监控于一体，
                        完美地实现了库存管理的闭环模式
                        </p>
                    </div>
                </div>
            </div>
            <div class="row group2">
                <div class="col4 wow fadeInUpMin">
                    <div class="pro-box">
                        <img src="../../../assets/images/index-pic3.png" class="img-area pic3">
                        <strong>销量计划</strong>
                        <p>以商家的商品信息、历史销售信息、促销方式、时段等数据为基础，
                            基于机器学习算法、多品类、多层次的预测模型对入仓的百万级商品进行预测，有效减少商家收集数据做预测分析的时间和提升预测准确度
                        </p>
                    </div>
                </div>
                <div class="col4 wow fadeInUpMin" data-wow-delay="0.2s">
                    <div class="pro-box">
                        <img src="../../../assets/images/index-pic4.png" class="img-area pic4">
                        <strong>智能补货</strong>
                        <p>基于京东AI技术和大数据分析预测商品的未来销量，通过先进的补货模型和科学合理的补货参数输出补货建议，
                        提升补货精准度，降低周转与库存成本，全面提升商家库存管理能力
                        </p>
                    </div>
                </div>
                <div class="col4 wow fadeInUpMin" data-wow-delay="0.4s">
                    <div class="pro-box">
                        <img src="../../../assets/images/index-pic5.png" class="img-area pic5">
                        <strong>滞销处理</strong>
                        <p>根据不同类型滞销场景系统自动给出对应的处理建议，可视化展示滞销商品分布、分级，
                                    智能给出处理建议，帮助商家轻松找到仓里的“问题商品”，高周转、无销售、残品、脏品、临期、过期商品
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="our-advantages">
            <h1 class="wow fadeInUpMin">我们的优势</h1>
            <div class="row">
                <div class="col6 wow fadeIn">
                    <img class="pic-area cbg1" src="../../../assets/images/adv-01.jpg">
                        <div class="mask mask1"></div>

                    <div class="txt-area">
                        <img class="num" src="../../../assets/images/num1.png">
                        <strong>销量预测，预知未来</strong>
                        <p>赋能卖家预测能力，提供多种维度不同模型的预测方式，覆盖全品类、个性化的预测需求</p>
                    </div>
                </div>
                <div class="col6 wow fadeIn">
                    <img class="pic-area cbg2" src="../../../assets/images/adv-02.jpg">
                        <div class="mask mask2"></div>

                    <div class="txt-area t3">
                        <img class="num" src="../../../assets/images/num2.png">
                        <strong>合理补货，降低周转</strong>
                        <p>提升补货精准度、提高现货率、提升商家工作效率、降低库存周转与库存成本，结合销量预测和多种补货模型适配，自动化给出补货建议</p>
                    </div>
                </div>
                <div class="col6 wow fadeIn">
                    <img class="pic-area cbg3" src="../../../assets/images/adv-03.jpg">
                        <div class="mask mask3"></div>

                    <div class="txt-area t3">
                        <img class="num" src="../../../assets/images/num3.png">
                        <strong>快速处理滞销品，降低成本</strong>
                        <p>结合历史及预测销量、货轻松锁定滞销商品、指导商家降价清仓、多样退货场景、可视化滞销概览</p>
                    </div>
                </div>
                <div class="col6 wow fadeIn">
                    <img class="pic-area cbg4" src="../../../assets/images/adv-04.jpg">
                        <div class="mask mask4"></div>

                    <div class="txt-area">
                        <img class="num" src="../../../assets/images/num4.png">
                        <strong>更智能的库存优化能力</strong>
                        <p>利用人工智能与运筹优化技术，通过数学建模与系统仿真的方式，持续优化库存周转，提升人效降低成本</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footerBar/>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import {WOW} from 'wowjs'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    headerBar: () => import('../components/headerBar/HeaderBar.vue'),
    footerBar: () => import('../components/footer/Footer.vue')
  },
  data () {
    // 这里存放数据
    return {

    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {

  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    var wow = new WOW({
        live: false
    })
    wow.init()
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//../../..import url(); 引入公共css类
// ../../..import "common";
@import "../../../assets/muss/muss";
@import "../../../assets/scss/yscLogin.scss";
.zk-inner {position: relative;}

.focus-area {
    height: 600px;
    background-color: #0e1347;
    min-width: 1300px;
    .zk-inner {height:600px; }
    .txt-area {
        position: absolute;color:#fff;top:36%;left: 40px;opacity: 0.9;
        strong {display: block;font-size: 48px;font-weight: 100;height:72px;}
        span {display: block;font-size: 36px;font-weight: 100;}
        p {font-size: 16px; width:550px;margin-top: 10px;font-weight: 100;line-height: 25px;}
    }
}

.animation-area {
  width: 100%;
  height: 600px;
  position: absolute;
  right: 80px;
}
.animation-inner {
  position: relative;
  width: 100%;
  height: 600px;
    .a1 {position: absolute;
        width: 260px;
        height: 150px;
        right: 80px;
        bottom: 60px;
        z-index: 2;
        background: url(../../../assets/images/ani-1.png) no-repeat;
        background-size: 100%;
    }
    .a2 {position: absolute;
        width: 400px;
        height: 400px;
        right: 0;
        top: 65px;
        z-index: 4;
        background: url(../../../assets/images/ani-2.png) no-repeat;
        background-size: 100%;
    }
    .a3 {position: absolute;
        width: 230px;
        height: 300px;
        right: 140px;
        bottom: 90px;
        z-index: 6;
        background: url(../../../assets/images/ani-3.png) no-repeat;
        background-size: 100%;
    }
    .a4 {position: absolute;
        width: 340px;
        height: 210px;
        right: 30px;
        top: 80px;
        z-index: 8;
        background: url(../../../assets/images/ani-4.png) no-repeat;
        background-size: 100%;
    }
    .a5 {position: absolute;
        width: 300px;
        height: 230px;
        right: 72px;
        bottom: 60px;
        opacity: 0.6;
        z-index: 10;
        background: url(../../../assets/images/ani-5.png) no-repeat;
        background-size: 100%;
    }
    .a6 {position: absolute;
        width: 270px;
        height: 500px;
        right: 60px;
        bottom: 130px;
        opacity: 0.4;
        z-index: 4;
        background: url(../../../assets/images/ani-6.png) no-repeat;
        background-size: 100%;
    }
    .a7 {position: absolute;
        width: 400px;
        height: 300px;
        right: 20px;
        bottom: 50px;
        opacity: 0.5;
        z-index: 4;
        background:url(../../../assets/images/ani-8.png) no-repeat;
        background-size: 100%;
    }
    .lg {
    position: absolute;
    width: 110px;
    height: 120px;
    right: 168px;
    top: 100px;
    z-index: 20;
    background:url(../../../assets/images/logo2.png) no-repeat;
    background-size: 100%;
    @include animation(moves 3s infinite linear);
  }

}
img{
    display: block;
}

@include keyframes(moves) {
    0%{top: 100px;}
    25%{top: 110px;}
    50%{top: 100px;}
    75%{top: 110px;}
    100%{top: 100px;}
}

.product-info {
  text-align: center;
  .row {margin-bottom: 20px;}
}

.pro-box {
    width:360px;
    margin:0 auto;
    p {text-align:left;}
    strong {font-size: 24px;font-weight: 400;}
    .img-area {width:240px;height: 300px;margin:0 auto;
    background-size: cover; background-position: bottom center;}
}

.our-advantages {
  padding: 20px 0;margin-bottom: 40px;
  strong {font-size: 24px;font-weight: 400;}
  p {text-align:left;padding:10px 0;margin: 0;}
  .col6 {position:relative;text-align: left;}
  .txt-area {color:#fff; position: absolute;
      @include transition(all 0.4s);top:50%;font-weight: 200;
      width: 360px;left:50%;margin:-60px 0 0 -125px;}
  .t3 {color:#333;}
  .pic-area {
      height: 390px;
      width: 100%;
      position:relative;
      background-color: #ccc;
      background-size: 100%;
      background-position: center;
      @include transition(all 0.4s);
  }
  .num {width: 130px;height: 130px;position: absolute;
  @include border-radius(50%);
      top:50%;left:50%; margin: -70px 0 0 -310px;line-height:90px;
      background-size: 100%;
      background-position: center;
  }
  .mask {width: 100%;height: 390px;opacity: 0.9;
  @include transition(all 0.4s);
}
  .mask1 {background-color: #333;position: absolute;
      top:0;
      left:0; }
  .mask2 {background-color: #e0e3e6;position: absolute;
      top:0;
      left:0;}
  .mask3 {background-color: #e0e3e6;position: absolute;
      top:0;
      left:0;}
  .mask4 {background-color: #4185f4;position: absolute;
      top:0;
      left:0;}

  .col6:hover {
      .mask {opacity: 0.1;}
      .pic-area {background-size: 102%;}
      .txt-area { top: 80%; opacity: 0;}
  }
}

.guide-reg {
    text-align: center;
    margin-bottom: 40px;
    p {margin-bottom: 30px;font-size: 18px;}
    .btn-reg {width: 120px;height: 36px;line-height: 36px;
    @include border-radius(5px);
        margin: 0 auto;color:#fff;background-color: #333;display: inline-block;
        @include transition(all 0.4s);
        }
    .btn-reg:hover {background-color:#4185f4; }
}

</style>
